import gridStateCCReducer from './gridStateCCReducer';

export default gridStateCCReducer;